import React from "react";
import { useTrafficShapingView } from "../TrafficShapingList.context";
import { SortOption } from "./TrafficShapingFilter.types";

export function useTrafficShapingFilter() {
  const {
    ai_traffic_items,
    isItemSelected,
    searchKeyword,
    selectItem,
    selectionDisabled,
    setSearchKeyword,
    setSortOption,
    reloadAITrafficShapingItems,
    sortOptions,
    sortOption,
    unselectItem,
  } = useTrafficShapingView();

  const onChangeSort = React.useCallback(
    (e: any, item: SortOption) => {
      setSortOption(item);
    },
    [setSortOption]
  );

  const availablesForSelect = React.useCallback(() => {
    return ai_traffic_items?.content || [];
  }, [ai_traffic_items?.content]);

  const areAllSelectedOnCurrentPage = React.useMemo(() => {
    const availableForSelect = availablesForSelect();
    return (
      availableForSelect.length > 0 &&
      availableForSelect.filter(isItemSelected).length ===
        availableForSelect.length
    );
  }, [availablesForSelect, isItemSelected]);

  const toggleAllOnCurrentPage = React.useCallback(() => {
    const availableForSelect = availablesForSelect();
    availableForSelect?.forEach(
      areAllSelectedOnCurrentPage
        ? unselectItem
        : (item) => {
            !isItemSelected(item) && selectItem(item);
          }
    );
  }, [
    areAllSelectedOnCurrentPage,
    availablesForSelect,
    selectItem,
    unselectItem,
    isItemSelected,
  ]);

  const checkAllDisabled = React.useMemo(() => {
    const availables = availablesForSelect();
    return availables.length === 0 || selectionDisabled;
  }, [availablesForSelect, selectionDisabled]);

  return {
    areAllSelectedOnCurrentPage,
    checkAllDisabled,
    onChangeSort,
    reloadAITrafficShapingItems,
    searchKeyword,
    setSearchKeyword,
    sortOptions,
    toggleAllOnCurrentPage,
    sortedBy: sortOption.value,
  };
}
